import React, { useEffect, useState } from 'react'
import { addLocation } from '../Logic/index01';
import { construct, messageDisplay } from '../Auth/Util';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { CircularProgress } from 'react-loader-spinner';
import { useGeolocated } from "react-geolocated"
import {styled,keyframes} from 'styled-components';
import {useNavigate} from 'react-router-dom'

function CenterPage({action}) {


const [open, setOpen] = useState(false);
const [notify, setNotify] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [confirmed, setConfirmed] = useState(false);
const [btnLabel, setBtnLabel] = useState("Upload business location");
const send = useNavigate();





const toggle = async (v) => {
  if(open){
    setOpen(false);
  }else{
    setOpen(true);
    setNotify(v.id);
  }
};




function pullUpdate () {
  setConfirmed(true);
  setBtnLabel("✓ Confirmed!");
  setTimeout(() => {
    setConfirmed(false);
    setBtnLabel("Upload business location");
  }, 3000);

  setIsLoading(true);
   if(navigator.geolocation)
      navigator.geolocation.getCurrentPosition(async (position) => {
        if(position != null){
            setIsLoading(false);
            let res = await addLocation(position.coords,0,send);
              messageDisplay(res +" updated.",0)
        }
      },(error) => {
        setIsLoading(false);
         messageDisplay(error.message,1)          
      });

}



  return (
    <div className='flex items-center justify-center h-screen'>
    
        <div  className='flex justify-center align-middle text-center w-full h-[70vh] m-5 md:w-[80%] md:m-0 shadow-xl bg-white rounded-lg'>
            
            <div className='p-5 self-center'>
                <div className=' text-center m-5'>
                  <h5 className=' '>Before clicking the upload to server button be sure to be at your business location</h5>
                 
                </div>
                <div className='flex justify-center w-full '>
                     <ConfirmBtn onClick={(e) => pullUpdate()}  disabled={confirmed}>
                        {isLoading ? <CircularProgress color='#ffffff' width={25} height={25} /> : btnLabel}
                      </ConfirmBtn>
                </div>
            </div>
            <XMarkIcon className='cursor-pointer pr-1 md:pr-6' onClick={action}  width={60} height={60}/>   
           
         </div>
    </div>
  
  )
}


const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;



/* ── confirm button ── */
const ConfirmBtn = styled.button`
  bottom: 28px; left: 20px; right: 20px;
  padding:15px;
  height: 58px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border: none; border-radius: 18px;
  color: #ffffff;
  font-size: 15px; font-weight: 800;
  letter-spacing: 0.5px;
  cursor: pointer;
  box-shadow: 0 8px 28px rgba(37,99,235,0.45);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  animation: ${fadeUp} 0.5s ease 0.45s both;
  &:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(37,99,235,0.55); color:#f5f5f5; }
  &:active { transform: translateY(0); box-shadow: 0 4px 16px rgba(37,99,235,0.35); }
`;

export default CenterPage
